import React from 'react';
import './RoutePlanningFlow.css';

const RoutePlanningFlow = () => {
  return (
    <div className="route-planning-flow">
      <h3>How Looway Works?</h3>
      
      <div className="flow-container">
        {/* Step 1: Start */}
        <div className="flow-step start-step">
          <div className="step-icon">
            <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
              <circle cx="100" cy="100" r="80" fill="#004C10" stroke="#28a745" strokeWidth="4"/>
              <path d="M70 100 L90 120 L130 80" stroke="white" strokeWidth="6" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div className="step-content">
            <h3>Start Your Journey</h3>
            <p>Enter your starting point and destination</p>
          </div>
        </div>

        {/* Arrow */}
        <div className="flow-arrow">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 17L17 7M17 7H7M17 7V17" stroke="#28a745" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        {/* Step 2: Journey Preferences */}
        <div className="flow-step">
          <div className="step-icon">
            <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
              <circle cx="100" cy="100" r="80" fill="#8BC34A" stroke="#28a745" strokeWidth="3"/>
              <path d="M70 80 L90 100 L130 60" stroke="white" strokeWidth="4" fill="none" strokeLinecap="round"/>
              <path d="M70 120 L90 140 L130 100" stroke="white" strokeWidth="4" fill="none" strokeLinecap="round"/>
              <path d="M70 100 L90 120 L130 80" stroke="white" strokeWidth="4" fill="none" strokeLinecap="round"/>
            </svg>
          </div>
          <div className="step-content">
            <h3>Set Journey Preferences</h3>
            <p>Configure your route planning parameters</p>
          </div>
        </div>

        {/* Arrow */}
        <div className="flow-arrow">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 17L17 7M17 7H7M17 7V17" stroke="#28a745" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        {/* Step 3: Transport Mode */}
        <div className="flow-step">
          <div className="step-icon">
            <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
              <rect x="40" y="120" width="120" height="40" rx="20" fill="#28a745" stroke="#004C10" strokeWidth="3"/>
              <circle cx="70" cy="160" r="15" fill="#333"/>
              <circle cx="130" cy="160" r="15" fill="#333"/>
              <rect x="60" y="100" width="80" height="30" rx="5" fill="#28a745"/>
              <rect x="70" y="110" width="60" height="10" rx="2" fill="#004C10"/>
            </svg>
          </div>
          <div className="step-content">
            <h3>Choose Transport Mode</h3>
            <p>Select car, public transport, cycling or walking</p>
          </div>
        </div>

        {/* Arrow */}
        <div className="flow-arrow">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 17L17 7M17 7H7M17 7V17" stroke="#28a745" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        {/* Step 4: Route Generation */}
        <div className="flow-step">
          <div className="step-icon">
            <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
              <path d="M50 100 Q100 50 150 100 Q100 150 50 100" fill="#28a745" stroke="#004C10" strokeWidth="3"/>
              <circle cx="100" cy="100" r="30" fill="#28a745"/>
              <path d="M85 100 L95 110 L115 90" stroke="white" strokeWidth="3" fill="none" strokeLinecap="round"/>
            </svg>
          </div>
          <div className="step-content">
            <h3>Generate Route</h3>
            <p>Our AI calculates the optimal path with toilet stops</p>
          </div>
        </div>

        {/* Arrow */}
        <div className="flow-arrow">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 17L17 7M17 7H7M17 7V17" stroke="#28a745" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        {/* Step 5: Results */}
        <div className="flow-step end-step">
          <div className="step-icon">
            <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
              <rect x="40" y="60" width="120" height="80" rx="10" fill="#004C10" stroke="#28a745" strokeWidth="3"/>
              <path d="M60 80 L80 100 L140 60" stroke="white" strokeWidth="4" fill="none" strokeLinecap="round"/>
              <circle cx="70" cy="120" r="8" fill="#28a745"/>
              <circle cx="110" cy="120" r="8" fill="#28a745"/>
              <circle cx="150" cy="120" r="8" fill="#28a745"/>
            </svg>
          </div>
          <div className="step-content">
            <h3>Get Your Route</h3>
            <p>Select the ideal loo locations and open the route in Google Maps</p>
          </div>
        </div>
      </div>

      {/* Preferences Details - Horizontal Grid */}
      <div className="preferences-section">
        <h3>Journey Preferences</h3>
        <div className="preferences-grid">
          <div className="preference-item">
            <div className="preference-icon">
              <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                <circle cx="100" cy="100" r="80" fill="#004C10" stroke="#28a745" strokeWidth="3"/>
                <circle cx="100" cy="100" r="60" fill="none" stroke="white" strokeWidth="4"/>
                <circle cx="100" cy="100" r="50" fill="none" stroke="white" strokeWidth="2"/>
                <line x1="100" y1="100" x2="100" y2="60" stroke="white" strokeWidth="4" strokeLinecap="round"/>
                <line x1="100" y1="100" x2="130" y2="100" stroke="white" strokeWidth="4" strokeLinecap="round"/>
              </svg>
            </div>
            <div className="preference-content">
              <h4>Journey Time</h4>
              <p>Set your preferred travel start time</p>
            </div>
          </div>

          <div className="preference-item">
            <div className="preference-icon">
              <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                <circle cx="100" cy="100" r="80" fill="#28a745" stroke="#004C10" strokeWidth="3"/>
                <path d="M60 100 Q100 60 140 100 Q100 140 60 100" fill="none" stroke="white" strokeWidth="4"/>
                <circle cx="80" cy="100" r="8" fill="white"/>
                <circle cx="120" cy="100" r="8" fill="white"/>
                <circle cx="100" cy="80" r="8" fill="white"/>
                <circle cx="100" cy="120" r="8" fill="white"/>
              </svg>
            </div>
            <div className="preference-content">
              <h4>Stop Frequency</h4>
              <p>Choose how often you want to stop</p>
            </div>
          </div>

          <div className="preference-item">
            <div className="preference-icon">
              <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                <circle cx="100" cy="100" r="80" fill="#8BC34A" stroke="#28a745" strokeWidth="3"/>
                <line x1="60" y1="100" x2="140" y2="100" stroke="white" strokeWidth="4" strokeLinecap="round"/>
                <line x1="100" y1="60" x2="100" y2="140" stroke="white" strokeWidth="4" strokeLinecap="round"/>
                <circle cx="100" cy="100" r="20" fill="none" stroke="white" strokeWidth="3"/>
                <circle cx="100" cy="100" r="40" fill="none" stroke="white" strokeWidth="2"/>
              </svg>
            </div>
            <div className="preference-content">
              <h4>Distance Tolerance</h4>
              <p>Set maximum detour distance</p>
            </div>
          </div>

          <div className="preference-item">
            <div className="preference-icon">
              <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                <circle cx="100" cy="100" r="80" fill="#28a745" stroke="#004C10" strokeWidth="3"/>
                <circle cx="100" cy="140" r="25" fill="white"/>
                <path d="M75 140 Q100 120 125 140" fill="none" stroke="white" strokeWidth="3"/>
                <circle cx="85" cy="130" r="4" fill="white"/>
                <circle cx="115" cy="130" r="4" fill="white"/>
                <path d="M90 110 Q100 100 110 110" fill="none" stroke="white" strokeWidth="2"/>
                <line x1="100" y1="100" x2="100" y2="80" stroke="white" strokeWidth="3" strokeLinecap="round"/>
                <line x1="80" y1="80" x2="120" y2="80" stroke="white" strokeWidth="3" strokeLinecap="round"/>
              </svg>
            </div>
            <div className="preference-content">
              <h4>Accessibility</h4>
              <p>Walking distance to facilities</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoutePlanningFlow;
